/* eslint-disable */
export interface EmployeeJobInterestDto {
  Comments: string;
  Status: string;
  DateModified: Date;
  Hrref: number;
  InterestSubmittedId: string;
  JobNumber: string;
  ModifiedUser: string;
  OriginalEndDate: Date;
  OriginalShift: number;
  OriginalStartDate: Date;
  StatusIsFinal: boolean;
  SubmittedOn: Date;
  // this one appears incoorect (mispelled)
  vManpowerOpeningId: string;
  // this one appears correct (Peter?)
  vManPowerOpeningId?: string;
  EmployeeName: string;
  JobID: string;
}
